import { DesktopAdapter } from './DesktopAdapter'
import { MobileAdapter } from './MobileAdapter'
import type { InputAdapter, InputFrame } from './types'
import { EMPTY_INPUT } from './types'

export function detectTouchPreferred(preferTouch: boolean | null): boolean {
  if (preferTouch !== null) return preferTouch
  return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0
}

export class InputManager {
  readonly desktop: DesktopAdapter
  readonly mobile: MobileAdapter
  private active: InputAdapter
  private touchMode: boolean
  private enabled = false

  constructor(canvas: HTMLElement, preferTouch: boolean | null) {
    this.desktop = new DesktopAdapter(canvas)
    this.mobile = new MobileAdapter()
    this.touchMode = detectTouchPreferred(preferTouch)
    this.active = this.touchMode ? this.mobile : this.desktop
  }

  get isTouch(): boolean {
    return this.touchMode
  }

  setTouchMode(touch: boolean): void {
    if (this.touchMode === touch && this.active === (touch ? this.mobile : this.desktop)) {
      return
    }
    this.touchMode = touch
    this.active.setEnabled(false)
    this.active = touch ? this.mobile : this.desktop
    // Mid-game смена режима: новый адаптер должен снова слушать ввод
    this.active.setEnabled(this.enabled)
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled
    this.desktop.setEnabled(false)
    this.mobile.setEnabled(false)
    this.active.setEnabled(enabled)
  }

  sample(dt: number): InputFrame {
    return this.active.sample(dt) ?? EMPTY_INPUT
  }

  dispose(): void {
    this.desktop.dispose()
    this.mobile.dispose()
  }
}
